import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AccessControlState } from '../state/access-control.state';

export const accessControlFeatureKey = 'access-control';

export const selectFeature = createFeatureSelector<AccessControlState>(accessControlFeatureKey);

export const selectAccessControlContractCompanyTemplates = createSelector(
    selectFeature,
    (state) => state.templates.contractTemplates
);

export const selectAccessControlClientTemplates = createSelector(
    selectFeature,
    (state) => state.templates.clientTemplates
);

export const selectAccessControlTemplateNameValidation = createSelector(
    selectFeature,
    (state) => state.templates.contractTemplateNameExists
);
